import React from 'react';

import PointBox from "./PointBox";

export default function PointGroup (props) {
    return (
        <>
            {
                props.data && props.data.map((item, index) => {
                    return (
                        <div key={`point-group-${index}`} className="pointGroup">
                            {
                                item.products &&
                                (<div className="pointGroupList">
                                    <PointBox data={item.products} type={item.type}  loginJwt={props.loginJwt}/>
                                </div>)
                            }
                        </div>
                    )
                })
            }
        </>
    );
}
